const authStorageVars = {
  /**
   * @returns {string}
   */
  TokenPath () { return 'auth.token' }
}

export default authStorageVars



// WEBPACK FOOTER //
// ./src/common/auth/storage/vars-manager.js